//User context
export const LOG_IN_SUCCEED = 'LOG_IN_SUCCEED';
export const LOG_IN_ERROR = 'LOG_IN_ERROR';
export const SIGN_UP_SUCCEED = 'SIGN_UP_SUCCEED';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';
export const GET_USER = 'GET_USER';
export const LOG_OUT = 'LOG_OUT';
export const CREATE_ACCOUNT_SUCCEED = 'CREATE_ACCOUNT_SUCCEED';
export const CREATE_ACCOUNT_ERROR = 'CREATE_ACCOUNT_ERROR';
export const UPDATE_SETTINGS_SUCCEED = 'UPDATE_SETTINGS_SUCCEED'
export const UPDATE_SETTINGS_FAILED = 'UPDATE_SETTINGS_FAILED'
export const CLEAN_USER_SETTINGS = 'CLEAN_USER_SETTINGS';
export const GET_SETTINGS = 'GET_SETTINGS';


//Messages context
export const GET_MESSAGES_SUCCEED = 'GET_MESSAGES_SUCCEED';
export const GET_MESSAGES_ERROR = 'GET_MESSAGES_ERROR';
export const DELETE_MESSAGE_SUCCEED = 'DELETE_MESSAGE_SUCCEED';
export const DELETE_MESSAGE_ERROR = 'DELETE_MESSAGE_ERROR';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';

//Thoughts Context 

export const GET_THOUGHTS_SUCCEED = 'GET_THOUGHTS_SUCCEED';
export const GET_THOUGHTS_ERROR = 'GET_THOUGHTS_ERROR';
export const GET_THOUGHT_SUCCEED = 'GET_THOUGHT_SUCCEED';
export const GET_THOUGHT_ERROR = 'GET_THOUGHT_ERROR';
export const LIKE_SUCCEED = 'LIKE_SUCCEED';
export const LIKE_ERROR = 'LIKE_ERROR';
export const CREATE_THOUGHT_SUCCEED = 'CREATE_THOUGHT_SUCCEED';
export const CREATE_THOUGHT_ERROR = 'CREATE_THOUGHT_ERROR';
export const CREATE_COMMENT_SUCCEED = 'CREATE_COMMENT_SUCCEED';
export const CREATE_COMMENT_ERROR = 'CREATE_COMMENT_ERROR';
export const DELETE_THOUGHT_SUCCEED = 'DELETE_THOUGHT_SUCCEED';
export const DELETE_THOUGHT_ERROR = 'DELETE_THOUGHT_ERROR';
export const LIKE_COMMENT_SUCCEED = 'LIKE_COMMENT_SUCCEED';
export const LIKE_COMMENT_ERROR = 'LIKE_COMMENT_ERROR';
export const DELETE_COMMENT_SUCCEED = 'DELETE_COMMENT_SUCCEED';
export const DELETE_COMMENT_ERROR = 'DELETE_COMMENT_ERROR';

// modal context

export const OPEN_ERROR_MODAL = 'OPEN_ERROR_MODAL';
export const OPEN_NOTIFICATION_MODAL = 'OPEN_NOTIFICATION_MODAL';
